import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getMenuItemsByRole } from "../../../../helpers/HelperFunctions";
import MenuItem from "./NavigationItem";

interface INavigationItems {
  currentRoute: string;
  isCollapsed?: boolean;
}

const NavigationItems = ({ currentRoute, isCollapsed }: INavigationItems) => {
  const currentProfile: any = useSelector((state: any) => state.login.currentProfile);
  const dependenteProfile: any = useSelector((state: any) => state.login.dependenteProfile);
  const [menuItems, setMenuItems] = useState<any[]>([]);

  useEffect(() => {
    setMenuItems(getMenuItemsByRole(currentProfile, dependenteProfile));
  }, [currentProfile, dependenteProfile]);

  return (
    <nav style={{ padding: "8px 0" }}>
      {menuItems.map((item) => {
        return (
          <MenuItem
            key={item.nome}
            path={item.path}
            currentRoute={currentRoute}
            isHighlighted={() => item.isHighlight(currentRoute)}
            icon={item.icon}
            menuItemDescription={item.nome}
            isCollapsed={isCollapsed}
          />
        );
      })}
    </nav>
  );
};

export default NavigationItems;
